module.exports = __webpack_public_path__ + "static/storm-b09c2fa46ea6e5ceb55f8531baf28e8b.png";